/* Tune LP · cart drawer bridge.
   The landing page hides the theme header, so sending anyone to /cart strands
   them on a page with no way back. This opens the theme's own drawer in place.

   This theme's drawer is <cart-drawer> (assets/cart-drawer.js). It exposes no
   open(), it toggles: element.toggleDrawerClasses(), with element.isOpen as
   the state flag, and .wt-cart__trigger as its click trigger.

   The bridge also guarantees the selector contract the buy module checks for
   (cart-drawer / [data-cart-drawer] / #CartDrawer with an .open()), so the
   post-add-to-cart drawer call works too. */
(function () {
  if (window.TuneCart) return;

  var TOGGLES = [
    '.wt-cart__trigger',
    '[data-cart-drawer-toggle]',
    '#cart-icon-bubble a',
    '#shopify-section-cart-icon-bubble a',
    '.header__icon--cart'
  ];

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function isOpen(el) {
    if (!el) return false;
    return el.isOpen === true || el.hasAttribute('open');
  }

  function openViaMethod() {
    var el = drawerEl();
    if (!el) return false;
    if (isOpen(el)) return true;
    // This theme's own toggle. Direct call works even when the drawer's click
    // triggers were never wired (cart type set to page).
    if (typeof el.toggleDrawerClasses === 'function') {
      try { el.toggleDrawerClasses(); return isOpen(el); } catch (e) {}
    }
    var alt = ['show', 'showDrawer', 'openDrawer'];
    for (var i = 0; i < alt.length; i++) {
      if (typeof el[alt[i]] === 'function') {
        try { el[alt[i]](); return true; } catch (e) {}
      }
    }
    return false;
  }

  function openViaTrigger() {
    for (var i = 0; i < TOGGLES.length; i++) {
      var t = document.querySelector(TOGGLES[i]);
      // The theme header is display:none here, but a synthetic click still
      // runs its handler, which is all the drawer needs.
      if (t && !t.hasAttribute('data-lp-cart')) {
        try { t.click(); if (isOpen(drawerEl())) return true; } catch (e) {}
      }
    }
    return false;
  }

  function open() {
    if (openViaMethod()) return true;
    if (openViaTrigger()) return true;
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    if (isOpen(drawerEl())) return true;
    // Last resort only: no usable drawer on this page.
    window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
    return false;
  }

  // Ask the theme to re-render the drawer contents after an AJAX add.
  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
  }

  function refresh() {
    var root = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // Give the buy module something to find: patch open() onto the real drawer,
  // or stand in a proxy until the drawer element exists.
  function ensureContract() {
    var el = drawerEl();
    if (el) {
      if (typeof el.open !== 'function') {
        try {
          el.open = function () { refreshDrawer(); open(); };
        } catch (e) {}
      }
      var stale = document.querySelector('[data-tune-cart-proxy]');
      if (stale) stale.remove();
      return;
    }
    if (document.querySelector('[data-tune-cart-proxy]')) return;
    var proxy = document.createElement('div');
    proxy.setAttribute('data-cart-drawer', '');
    proxy.setAttribute('data-tune-cart-proxy', '');
    proxy.setAttribute('hidden', '');
    proxy.open = function () { refreshDrawer(); open(); };
    document.body.appendChild(proxy);
  }

  window.TuneCart = { open: open, refresh: refresh, refreshDrawer: refreshDrawer, ensureContract: ensureContract };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureContract);
  } else {
    ensureContract();
  }
  // customElements upgrade and app-injected drawers land after first paint.
  [300, 1200, 2500].forEach(function (ms) { setTimeout(ensureContract, ms); });
})();
